export const CARS = [
  {
    id: "honda-civic",
    year: 2018,
    make: "Honda",
    model: "Civic EX",
    price: "$11,990",
    mileage: "68,000",
    salvage: false,
    transmission: { en: "Automatic CVT", es: "Automática CVT" },
    engine: { en: "2.0L 4-Cyl", es: "2.0L 4-Cil" },
    condition: { en: "Excellent", es: "Excelente" },
    image:
      "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxzZWRhbiUyMGNhciUyMHZlaGljbGV8ZW58MHx8fHwxNzkxNDgyNjQ4fDA&ixlib=rb-4.1.0&q=85",
    alt: { en: "Black Honda Civic sedan", es: "Sedán Honda Civic negro" },
  },
  {
    id: "toyota-camry",
    year: 2017,
    make: "Toyota",
    model: "Camry SE",
    price: "$8,950",
    mileage: "74,200",
    salvage: true,
    transmission: { en: "Automatic", es: "Automática" },
    engine: { en: "2.5L 4-Cyl", es: "2.5L 4-Cil" },
    condition: { en: "Fully Rebuilt", es: "Totalmente Reconstruido" },
    image:
      "https://images.unsplash.com/photo-1550355291-bbee04a92027?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxzZWRhbiUyMGNhciUyMHZlaGljbGV8ZW58MHx8fHwxNzkxNDgyNjQ4fDA&ixlib=rb-4.1.0&q=85",
    alt: { en: "Red Toyota Camry sedan", es: "Sedán Toyota Camry rojo" },
  },
  {
    id: "dodge-charger",
    year: 2016,
    make: "Dodge",
    model: "Charger SXT",
    price: "$10,400",
    mileage: "82,000",
    salvage: true,
    transmission: { en: "Automatic", es: "Automática" },
    engine: { en: "3.6L V6", es: "3.6L V6" },
    condition: { en: "Restored", es: "Restaurado" },
    image:
      "https://images.unsplash.com/photo-1609386464913-4cbfa39de540?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxkYXJrJTIwYXNwaGFsdCUyMG11c2NsZSUyMGNhciUyMGF1dG9tb3RpdmUlMjBzcG90bGlnaHQlMjBoZXJvfGVufDB8fHx8MTc5MTQ4MjY0NHww&ixlib=rb-4.1.0&q=85",
    alt: { en: "Dark grey Dodge Charger muscle car", es: "Dodge Charger gris oscuro" },
  },
  {
    id: "chevrolet-silverado",
    year: 2019,
    make: "Chevrolet",
    model: "Silverado 1500",
    price: "$16,800",
    mileage: "61,500",
    salvage: false,
    transmission: { en: "Automatic", es: "Automática" },
    engine: { en: "5.3L V8", es: "5.3L V8" },
    condition: { en: "Very Good", es: "Muy Bueno" },
    image:
      "https://images.unsplash.com/photo-1590053936004-faca6038bfec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxzdXYlMjB0cnVjayUyMHZlaGljbGV8ZW58MHx8fHwxNzkxNDgyNjQ4fDA&ixlib=rb-4.1.0&q=85",
    alt: { en: "Black Chevrolet Silverado pickup truck", es: "Camioneta Chevrolet Silverado negra" },
  },
  {
    id: "ford-f150",
    year: 2018,
    make: "Ford",
    model: "F-150 SuperCrew",
    price: "$14,500",
    mileage: "79,000",
    salvage: true,
    transmission: { en: "Automatic", es: "Automática" },
    engine: { en: "3.5L V6 EcoBoost", es: "3.5L V6 EcoBoost" },
    condition: { en: "Rebuilt", es: "Reconstruido" },
    image:
      "https://images.unsplash.com/photo-1637687200791-b3295dd30343?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxzdXYlMjB0cnVjayUyMHZlaGljbGV8ZW58MHx8fHwxNzkxNDgyNjQ4fDA&ixlib=rb-4.1.0&q=85",
    alt: { en: "Red Ford F-150 pickup truck", es: "Camioneta Ford F-150 roja" },
  },
  {
    id: "jeep-cherokee",
    year: 2017,
    make: "Jeep",
    model: "Grand Cherokee 4x4",
    price: "$12,300",
    mileage: "85,400",
    salvage: true,
    transmission: { en: "Automatic 4x4", es: "Automática 4x4" },
    engine: { en: "3.6L V6", es: "3.6L V6" },
    condition: { en: "Inspected", es: "Inspeccionado" },
    image:
      "https://images.unsplash.com/photo-1649793395985-967862a3b73f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxzdXYlMjB0cnVjayUyMHZlaGljbGV8ZW58MHx8fHwxNzkxNDgyNjQ4fDA&ixlib=rb-4.1.0&q=85",
    alt: { en: "Silver Jeep Grand Cherokee SUV", es: "SUV Jeep Grand Cherokee plateada" },
  },
];

export const SERVICE_IMAGES = {
  hero: "https://images.unsplash.com/photo-1580014317999-e9f1936787a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxkYXJrJTIwYXNwaGFsdCUyMG11c2NsZSUyMGNhciUyMGF1dG9tb3RpdmUlMjBzcG90bGlnaHQlMjBoZXJvfGVufDB8fHx8MTc5MTQ4MjY0NHww&ixlib=rb-4.1.0&q=85",
  mechanic:
    "https://images.unsplash.com/photo-1676018366904-c083ed678e60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxhdXRvJTIwbWVjaGFuaWMlMjBjYXIlMjByZXBhaXIlMjBvaWwlMjB0aXJlJTIwcGFpbnQlMjBnYXJhZ2V8ZW58MHx8fHwxNzkxNDgyNjQ0fDA&ixlib=rb-4.1.0&q=85",
  tires:
    "https://images.unsplash.com/photo-1645445522156-9ac06bc7a767?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjYXIlMjB0aXJlJTIwY2hhbmdlJTIwcmVwYWlyfGVufDB8fHx8MTc5MTQ4MjY0OHww&ixlib=rb-4.1.0&q=85",
  paint:
    "https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxhdXRvJTIwbWVjaGFuaWMlMjBjYXIlMjByZXBhaXIlMjBvaWwlMjB0aXJlJTIwcGFpbnQlMjBnYXJhZ2V8ZW58MHx8fHwxNzkxNDgyNjQ0fDA&ixlib=rb-4.1.0&q=85",
};

export const LOT_PHOTOS = [
  {
    src: "/photos/building-front.jpg",
    alt: {
      en: "The Family Auto Sales shop on Shannon Rd",
      es: "El taller de Family Auto Sales en Shannon Rd",
    },
  },
  {
    src: "/photos/building-angle.jpg",
    alt: {
      en: "Cars lined up in front of the shop bays",
      es: "Autos frente a las bahías del taller",
    },
  },
  {
    src: "/photos/lot-row.jpg",
    alt: {
      en: "Sedans and SUVs ready on the lot",
      es: "Sedanes y SUVs listos en el lote",
    },
  },
  {
    src: "/photos/lot-trucks.jpg",
    alt: {
      en: "Trucks and cars on the grass lot",
      es: "Camionetas y autos en el lote",
    },
  },
  {
    src: "/photos/lot-pad.jpg",
    alt: {
      en: "Vehicles waiting for service by the shop",
      es: "Vehículos esperando servicio junto al taller",
    },
  },
  {
    src: "/photos/lot-panorama.jpg",
    alt: {
      en: "A view across the Family Auto Sales lot",
      es: "Una vista del lote de Family Auto Sales",
    },
  },
  {
    src: "/photos/shop-interior.jpg",
    alt: {
      en: "Inside the shop — tire and wheel equipment",
      es: "Dentro del taller — equipo de llantas y rines",
    },
  },
  {
    src: "/photos/paint-booth.jpg",
    alt: {
      en: "The paint and body bay with a Jeep inside",
      es: "El área de pintura con un Jeep adentro",
    },
  },
];

export const CONTACT = {
  phone: "910-227-2322",
  phoneHref: "tel:+19102272322",
  address: "8670 Shannon Rd, Shannon, NC 28386",
  mapsUrl: "https://maps.google.com/?q=8670+Shannon+Rd+Shannon+NC+28386",
};
